import { createGlobalStyle } from "styled-components"
import media from "styled-media-query"

const GlobalStyles = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  * {
    box-sizing: border-box;
  }
  body {
    background: #16202c;
    line-height: 1;
    font-size: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

    --bodyPaddingTop: 94px;
    padding-top: var(--bodyPaddingTop);

    ${media.lessThan("large")`
      padding-top: 20px;
  `}

    --strongText: #1AABBF;
    --titulo: Fira Code;
    --conteudo: Source Sans Pro;
  }
  img {
    display: block;
  	width: 100%;
  	height: auto;
  }

  em {
    font-style: italic !important;
  }

  body.dark {
    --borders: #38444d;
    --texts: #8899a6;
    --comments: #fff;
    --postColor: #fff;
    --highlight: #0A8394;
    --mediumBackground: #0D0D0D;
    --background: #0D0D0D;
    --white: #fff;
    --black: #222;
    --linkText: #fff;
    --boxShadow: rgba(250, 250, 250, .12);
  }

  body.light {
    --borders: #dedede;
    --postColor: #111;
    --texts: #555555;
    --comments: #555555;
    --highlight: #1AABBF;
    --mediumBackground: #f0f0f3;
    --background: #f0f0f3;
    --white: #fff;
    --black: #222;
    --linkText: #222;
    --boxShadow: rgba(18, 18, 18, .12);
  }
`
export default GlobalStyles
